const mutations = {
    setLogin(state, value) {
        state.loggedIn = value;
    }
};
export default mutations;
